/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RemoteActionJobParameters } from './RemoteActionJobParameters';
export type RemoteActionExecutionJobResponseDto = {
  id: number;
  /**
   * unique UUID identifier
   */
  name: string;
  action: RemoteActionExecutionJobResponseDto.action;
  createdBy: string;
  parameters?: RemoteActionJobParameters;
  updatedAt: string;
  createdAt: string;
};
export namespace RemoteActionExecutionJobResponseDto {
  export enum action {
    REBOOT = 'REBOOT',
    LOG_REQUEST = 'LOG_REQUEST',
    FIRMWARE_UPDATE = 'FIRMWARE_UPDATE',
    COMMAND = 'COMMAND',
  }
}

